// components
import { StackLayout } from '@karehero/llama/pwa/templates/StackLayout/StackLayout';

// mui
import { Box } from '@mui/material';

/**
 * RootAdmin is the root layout for admin pages.
 * Uses StackLayout to support slide animations for stacked routes
 * (e.g. editor pages overlaying table pages).
 */
export const RootAdmin = () => {
  return (
    <StackLayout freezeOnRootStack={false}>
      {(outlet) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {outlet}
        </Box>
      )}
    </StackLayout>
  );
};

RootAdmin.displayName = 'RootAdmin';
export default RootAdmin;
